import { resolveMediaUrl } from '../../salon-admin/utils/mediaUrl';

/** Resolve kiosk landing media (logo, backdrop, icons) for browser display. */
export function resolveKioskMediaUrl(value) {
  return resolveMediaUrl(value) || '';
}

export function normalizeKioskLandingConfig(config) {
  if (!config || typeof config !== 'object') return config;
  const next = { ...config };

  if (next.brand && typeof next.brand === 'object') {
    const logoUrl = resolveKioskMediaUrl(next.brand.logoUrl);
    next.brand = {
      ...next.brand,
      logoUrl: logoUrl || next.brand.logoUrl || null,
    };
  }

  if (next.background && typeof next.background === 'object') {
    const backdropImageUrl = resolveKioskMediaUrl(next.background.backdropImageUrl);
    next.background = {
      ...next.background,
      backdropImageUrl: backdropImageUrl || next.background.backdropImageUrl || null,
    };
  }

  if (Array.isArray(next.cards)) {
    next.cards = next.cards.map((card) => {
      if (!card || typeof card !== 'object') return card;
      const iconUrl = resolveKioskMediaUrl(card.iconUrl);
      return {
        ...card,
        iconUrl: iconUrl || card.iconUrl || null,
      };
    });
  }

  return next;
}
